/**
 * @generated SignedSource<<a010481b21a9c4bff04c14c69178bbcb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TitleBarWithAction_resource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ancestors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "resourcePath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ResourceTreeTaxonomy",
      "kind": "LinkedField",
      "name": "taxonomies",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaxonomyIcons_taxonomies"
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Subscription_subscribable"
        }
      ],
      "type": "ResourceWithSubscription",
      "abstractKey": "__isResourceWithSubscription"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Breadcrumbs_page"
    }
  ],
  "type": "ResourceTreeLeaf",
  "abstractKey": "__isResourceTreeLeaf"
};

node.hash = "f759a1407f3308f132a3b3fb6cbf7a24";

module.exports = node;
